export default __webpack_public_path__ + "static/media/paid_pass_img.13d14748.png";